import type { ListProps as MuiListProps } from '@mui/material';
import { List as MuiList } from '@mui/material';

export type ListProps = MuiListProps;

/** List component. Based on MUI List: https://mui.com/material-ui/api/list/ */
export const List = (props: ListProps) => <MuiList {...props} data-testid="list" />;
